import { render, staticRenderFns } from "./ListArtwork.vue?vue&type=template&id=05adf31b&"
import script from "./ListArtwork.vue?vue&type=script&lang=js&"
export * from "./ListArtwork.vue?vue&type=script&lang=js&"
import style0 from "./ListArtwork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports